import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calendar-popup',
  templateUrl: './calendar-popup.component.html',
  styleUrls: ['./calendar-popup.component.scss']
})
export class CalendarPopupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
